import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { mapRecTypeToBaseType } from '../../ts/models/ContentType';
import { IViewRecommendationInfo } from '../../ts/models/IViewRecommendationInfo';
import { GetRecommendedViewsRequest } from '../../ts/ServerApi/requests/GetRecommendedViewsRequest';
import { HideRecommendationRequest } from '../../ts/ServerApi/requests/HideRecommendationRequest';
import { UndoHideRecommendationRequest } from '../../ts/ServerApi/requests/UndoHideRecommendationRequest';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { ServerService } from '../../ts/services/ServerService';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ServiceLocator } from '../../app/ServiceLocator';

export namespace ViewRecommendations {

  let getRecommendedViews: IListFetcher<IViewRecommendationInfo> = null;

  export function viewRecommendations(): ResourceQuery<IViewRecommendationInfo> {
    if (getRecommendedViews === null) {
      const fetcherFactory = ServiceLocator.get<FetcherFactory>('FetcherFactory');
      getRecommendedViews = fetcherFactory.getServerResourceFetcher(GetRecommendedViewsRequest, ServerApiMapper.vizRecommendations);
    }
    return new ResourceQuery(getRecommendedViews);
  }

  export function hideRecommendation(objectType: string, objectId: string): ng.IPromise<IResult> {
    const server: ServerService = ServiceLocator.get<ServerService>('ServerService');
    return server.sendRequest(new HideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

  export function undoHideRecommendation(objectType: string, objectId: string): ng.IPromise<IResult> {
    const server: ServerService = ServiceLocator.get<ServerService>('ServerService');
    return server.sendRequest(new UndoHideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

}

export type ViewRecommendations = typeof ViewRecommendations;
